import React from 'react'
import { LeftTextRightPicture, Quote, goldColour, CatchPhrase, CallToActionButtons, reMindTopics, reMindArgomenti } from './Home'
import BlueButton from '../components/BlueButton'
import { useNavigate } from 'react-router-dom'
import { PictureWithModal } from './Home';
import { GoldTags } from './Home'
import { useStateContext } from '../context/StateContext'
import T from '../components/Translation'

const HowItWorks = () => {
  const {language} = useStateContext()
  const navigate = useNavigate();
  return (
    <div className="how-it-works">
      <div style={{padding: "20px", display: "flex", justifyContent: "flex-start"}}>
        <BlueButton 
          home
          buttonStyle={{fontSize: "16px", padding: "10px 20px"}}
        />
      </div>
      <div style={{textAlign: "center", marginBottom: "15px"}}>
        <h1><T str={"howItWorks"}/></h1>
      </div>
      <div style={{padding: "40px"}}>
        <div style={{ margin: "0 auto"}}>        
        <T obj = {{
          en: <>  
            Music has an amazing connection with our emotional system. Just by thinking of a song it can easily 
            get stuck in our head, instantly bring memories back, good or bad. My aim is to help you attach 
            positive memories of growth and change to the <span style={{color: goldColour}}><b>reMind</b></span> songs so that they can help you speed up the process.
            <br/><br/>
            If you are reading this, you are likely someone that is looking to make some changes, and maybe you 
            are working with some wonderful professional that helps you navigate your own psyche. Session after 
            session you can slowly change, but no matter what techniques you are using, they all require the same 
            ingredient: consistent repetition, which is where most people struggle.
            <br/><br/>
            Repetition becomes even more effective if it is paired with emotional impact. Shock for example can 
            diminish the reps necessary for learning, but it sure isn't pleasant. Music is a super powerful way 
            to create new neural pathways while enjoying the ride.
            <br/><br/>
          </>,
          it: <>
            La musica ha una connessione straordinaria con il nostro sistema emotivo. A volte basta pensare ad una canzone e questa può facilmente 
            rimanere nella nostra testa, riportando istantaneamente alla memoria ricordi, buoni o cattivi. Il mio obiettivo è aiutarti 
            ad associare ricordi positivi di crescita e cambiamento alle canzoni di <span style={{color: goldColour}}><b>reMind</b></span> 
            in modo che possano accelerare il processo.
            <br/><br/>
            Se stai leggendo questo, probabilmente sei una persona che cerca di apportare dei cambiamenti, e forse stai lavorando con un 
            professionista meraviglioso che ti aiuta a navigare nella tua psiche. Sessione dopo sessione puoi cambiare lentamente, ma 
            indipendentemente dalle tecniche che usi, tutte richiedono lo stesso ingrediente: la ripetizione costante, l'ostacolo dove molte persone 
            incontrano difficoltà.
            <br/><br/>
            La ripetizione diventa ancora più efficace se è abbinata ad un impatto emotivo. Lo shock, ad esempio, può diminuire il numero di 
            ripetizioni necessarie per apprendere, ma sicuramente non è piacevole. La musica è un modo potentissimo per creare nuovi percorsi 
            neurali in modo semplice.
            <br/><br/>
          </>
        }}/>

          <div className="blue-background">
            <Quote dark author="Michael Bianco" fontSize="24px">
            <T obj = {{
              en: <>  
                "Take a moment to remember one song that has had a strong emotional impact in your life. 
                If you can, play it, if not, just try to recreate the feeling that it sparked inside of you. 
                How do you feel?"
              </>,
              it: <>  
                "Prenditi un momento per ricordare una canzone che ha avuto un forte impatto emotivo nella tua vita. 
                Se puoi, ascoltala, altrimenti cerca di ricreare la sensazione che ha suscitato dentro di te. 
                Come ti senti?"
              </>
            }}/>
            </Quote>
          </div>
          <h3 style={{marginBottom: "20px", marginTop: "40px"}}>
            <T obj = {{
                en: <>The Origin Story</>,
                it: <>Le Origini</>
              }}/>
          </h3>
          <T obj = {{
            en: <>  
              <span style={{color: goldColour}}><b>reMind</b></span> was conceived from the content of a live streaming programme called "SoulBrunch" that aired 
              between 2020 and 2022. Through a number of interactive segments, I have written and produced, together 
              with tens of thousands of people from the community in chat, songs and affirmations on personal growth topics.
              <br/><br/>
              Each song is the fruit of countless hours of conversation, deep thinking work and shared experiences. 
              Yes, you are not alone in your quest and you will find a lot of your own struggles embedded in the 
              lyrics of these songs, since they were written inspired by the struggles of a large enough set of 
              people, to become statistically universal.
              <br/><br/>
            </>,
            it: <>  
              <span style={{color: goldColour}}><b>reMind</b></span> è nato dai contenuti di un programma in diretta streaming chiamato "SoulBrunch" che è andato in onda 
              tra il 2020 e il 2022. Attraverso numerosi segmenti interattivi, ho scritto e prodotto, insieme 
              a decine di migliaia di persone della comunità in chat, canzoni e affermazioni su temi di crescita personale.
              <br/><br/>
              Ogni canzone è il frutto di innumerevoli ore di conversazione, lavoro di riflessione profonda ed esperienze condivise. 
              Sì, non sei solo nella tua ricerca e troverai molte delle tue stesse difficoltà incastonate nei 
              testi di queste canzoni, poiché sono state scritte ispirate dalle difficoltà di un numero sufficientemente ampio di 
              persone, da diventare statisticamente universali.
              <br/><br/>
            </>
          }}/>

          <h3 style={{marginBottom: "20px", marginTop: "40px"}}>
            <T obj = {{
              en: <>How to use the Song Affirmations</>,
              it: <>Come usare le Affermazioni In Musica</>
            }}/>
          </h3>
          <T obj = {{
            en: <>  
              The general structure of the songs have the difficult parts of the topics embedded in the verses, and 
              then a reframe of them in the choruses and "middle 8s". I suggest you learn them, particularly the 
              choruses, hum them in the shower or on the train. Acknowledge the difficulties in the verses, remember 
              you are not alone as thousands of people go through the same thing you go through, and repeat the 
              choruses and the parts you feel most connected to.
              <br/><br/>
            </>,
            it: <>  
              La struttura generale delle canzoni ha le parti difficili degli argomenti all'interno dei versi, e 
              poi una riformulazione o reframe positivo nei ritornelli. Ti consiglio di impararle, in particolare i 
              ritornelli, di canticchiarli sotto la doccia o sul treno. Riconosci le difficoltà nei versi che ti toccano, ricorda che 
              non sei solo, poiché migliaia di persone attraversano la stessa defficoltà che stai vivendo, e ripeti i 
              ritornelli e le parti a cui ti senti più connesso.
              <br/><br/>
            </>
          }}/>
          <h3 style={{marginBottom: "20px", marginTop: "40px"}}>
            <T obj = {{
              en: <>AI Song Recommendations</>,
              it: <>Raccomandazioni di Canzoni con AI</>
            }}/>
            </h3>
          <T obj = {{
            en: <>  
              One of the most powerful features of reMind is the ability to get personalized song recommendations based on how you feel.
              Simply write about your current emotional state, challenges, or thoughts, and our AI will analyze your words to suggest 
              the most relevant song that can serve as your personal affirmation.
              <br/><br/>
              The AI understands the emotional context of each song and matches it with your current state of mind, 
              helping you find the perfect musical affirmation for your journey of growth and healing.
              <br/><br/>
              <span style={{color: goldColour}}><b>reMind</b></span> is intended to be used as a complementary tool, under the supervision of qualified professionals. It is not a medical device, and it does not offer healing, treatment, or cures for any health condition. 
              Always consult with a healthcare professional for medical advice.
              <br/><br/>
            </>,
            it: <>  
              Una delle caratteristiche più potenti di reMind è la possibilità di ricevere raccomandazioni di canzoni personalizzate in base a come ti senti.
              Scrivi semplicemente riguardo al tuo stato emotivo attuale, le sfide o i pensieri, e la nostra IA analizzerà le tue parole per suggerire 
              una o più canzoni che possano servirti come affermazione personale.
              <br/><br/>
              L'IA cerca di comprendere il contesto emotivo di ogni canzone e lo abbina al tuo stato d'animo attuale, 
              aiutandoti a trovare l'affermazione musicale perfetta per il tuo viaggio di crescita.
              <br/><br/>
              <span style={{color: goldColour}}><b>reMind</b></span> reMind è stato realizzato come strumento complementare, 
              sotto la supervisione di professionisti qualificati. 
              Non è un dispositivo medico e non offre guarigione, trattamento o cure per alcuna condizione di salute. 
              Consultare sempre un professionista sanitario per consigli medici.
              <br/><br/>
            </>
          }}/>
          <PictureWithModal imageSource={language == "it" ? "/homePictures/aiExampleIt.png" : "/homePictures/aiExample.png"}/>
          <h3 style={{marginBottom: "20px", marginTop: "40px"}}>Topics Covered</h3>
          <GoldTags tagList = {language == "it" ? reMindArgomenti : reMindTopics}/>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks
